import { Divider } from '@occc-app/design-system';
import { StayVisibleWhileInProgress as StayVisibleWhileInProgressSwitcher } from '@occc-app/routes/CampaignComponents/components/StayVisibleWhileInProgress';
import { ProductChallengeEarningMechanism } from '@occc-app/routes/Challenge/types';

import { SweepstakesType } from '../types';

type StayVisibleWhileInProgressProps = {
  sweepstakesType: SweepstakesType;
  earningMechanism?: ProductChallengeEarningMechanism;
};

export const StayVisibleWhileInProgress: React.FC<StayVisibleWhileInProgressProps> = ({
  sweepstakesType,
  earningMechanism,
}) => {
  const isSpendBonusOrVarietyChallenge =
    sweepstakesType === SweepstakesType.SpendBonus ||
    (sweepstakesType === SweepstakesType.VarietyChallenge &&
      earningMechanism === 'varietyPurchaseOverTime');

  if (!isSpendBonusOrVarietyChallenge) {
    return null;
  }

  const parentFieldName =
    sweepstakesType === SweepstakesType.SpendBonus ? 'spendBonus' : 'productChallenge';

  return (
    <>
      <Divider />
      <StayVisibleWhileInProgressSwitcher
        name={`${parentFieldName}.stayVisibleWhileInProgress.isEnabled`}
      />
    </>
  );
};
